export const merchandisingConfig = {
  merchandisingTier: {
    label: 'Merchandising Tier',
    isVisible: true,
    type: 'select',
    data: [
      { id: 'Luxury' },
      { id: 'Premium Plus' },
      { id: 'Premium' },
      { id: 'Core/Premium' },
      { id: 'Core' },
      { id: 'Value' },
      { id: 'Recently Open' },
      { id: 'HOOL' },
    ],
    allowClear: true,
  },
};
